export function registerTemplateHelpers(context) {
  context.registerTemplateHelper('equals', equals);
  context.registerTemplateHelper('greaterThan', greaterThan);
  context.registerTemplateHelper('lessThan', lessThan);
  context.registerTemplateHelper('domId', domId);
  context.registerTemplateHelper('inspect', inspect);
  context.registerTemplateHelper('setContext', setContext);
}

function domId(object, prefix) {
  return prefix + '_' + (object?.id || object);
}

function equals(a, b, options) {
  return a === b ? options.fn(this) : options.inverse(this);
}

function greaterThan(a, b, options) {
  return a > b ? options.fn(this) : options.inverse(this);
}

function lessThan(a, b, options) {
  return a < b ? options.fn(this) : options.inverse(this);
}

function inspect(object) {
  return JSON.stringify(object, null, 2);
}

function setContext(context, options) {
  return options.fn(context);
}